import SelectAllButton from './SelectAllButton.component';

export default SelectAllButton;